import { useParams } from "react-router-dom";
import AtomAssistPageLoad from "src/views/assistant/components/AtomAssistPageLoad";
import { useChatStore } from "src/views/assistant/stores/ChatStore";
import { useSetWorkflowProductConfig } from "src/views/products/workflow/hooks/useWorkflowProductConfig";
import { ITEM_EQUIVALENCY_PRODUCT } from "./itemEquivalencyProduct";
import ItemEquivalencyChat from "./ItemEquivalencyChat";

const ItemEquivalencyChatPage = () => {
  const { dialogueId: dialogueIdParam } = useParams<{ dialogueId: string }>();
  const dialogueId = dialogueIdParam ? Number(dialogueIdParam) : undefined;

  // Set by the splash kickoff; fired by useStartChatOnMount inside the chat.
  const { initialUserMessage } = useChatStore();

  useSetWorkflowProductConfig(ITEM_EQUIVALENCY_PRODUCT);

  if (!dialogueId) {
    return <AtomAssistPageLoad />;
  }

  return (
    <ItemEquivalencyChat
      dialogueId={dialogueId}
      initialUserMessage={initialUserMessage}
    />
  );
};

export default ItemEquivalencyChatPage;
